import { api } from './connect'
import { getAuthInfo } from 'utils/MsGraphApiCall'
import i18next from 'i18next'
import { v4 as uuidv4 } from 'uuid'
import { ai } from '../config/appInsights'

class HttpClient {
  headers = (
    accessToken: string,
    params?: URLSearchParams,
    correlationIdOverride?: string
  ) => {
    return {
      headers: {
        Accept: 'text/plain',
        'vale-user-id': localStorage.getItem('user-id') ?? '',
        'vale-session-id': ai.context.getSessionId() ?? '',
        'Accept-Language': i18next.language.toUpperCase(),
        Authorization: `Bearer ${accessToken}`,
        'vale-correlation-id': correlationIdOverride ?? uuidv4()
      },
      params
    }
  }

  async post(
    url: string,
    body: Object | Array<any>,
    correlationIdOverride?: string
  ) {
    const { accessToken } = await getAuthInfo()
    const response = await api.post(
      url,
      body,
      this.headers(accessToken, undefined, correlationIdOverride)
    )

    if (response.status >= 200 && response.status <= 299) {
      return response.data
    }

    throw new Error(response.statusText)
  }

  async get(
    url: string,
    params?: URLSearchParams,
    correlationIdOverride?: string
  ) {
    const { accessToken } = await getAuthInfo()
    const response = await api.get(
      url,
      this.headers(accessToken, params, correlationIdOverride)
    )

    if (response.status >= 200 && response.status <= 299) {
      return response.data
    }

    throw new Error(response.statusText)
  }

  async put(
    url: string,
    body: Object | Array<any>,
    params?: URLSearchParams,
    correlationIdOverride?: string
  ) {
    const { accessToken } = await getAuthInfo()
    const response = await api.put(
      url,
      body,
      this.headers(accessToken, params, correlationIdOverride)
    )

    if (response.status >= 200 && response.status <= 299) {
      return response.data
    }

    throw new Error(response.statusText)
  }

  async patch(
    url: string,
    body: Object | Array<any>,
    correlationIdOverride?: string
  ) {
    const { accessToken } = await getAuthInfo()
    const response = await api.patch(
      url,
      body,
      this.headers(accessToken, undefined, correlationIdOverride)
    )

    if (response.status >= 200 && response.status <= 299) {
      return response.data
    }

    throw new Error(response.statusText)
  }

  async delete(
    url: string,
    body: Object | Array<any>,
    correlationIdOverride?: string
  ) {
    const { accessToken } = await getAuthInfo()
    const { headers } = this.headers(accessToken)

    const response = await api.delete(url, {
      headers,
      data: body
    })
    if (response.status >= 200 && response.status <= 299) {
      return response.data
    }

    throw new Error(response.statusText)
  }
}

export default new HttpClient()
